/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Type-specific share card configuration
 * @export
 * @interface GamificationShareTemplate
 */
export interface GamificationShareTemplate {
    /**
     * Share format identifier (e.g. GRID, PROGRESS_BAR, SCORE_CARD, BADGE)
     * @type {string}
     * @memberof GamificationShareTemplate
     */
    format?: string;
    /**
     * Admin-configurable share text template (supports variable interpolation)
     * @type {string}
     * @memberof GamificationShareTemplate
     */
    text?: string;
    /**
     * Type-specific image generation config
     * @type {{ [key: string]: any; }}
     * @memberof GamificationShareTemplate
     */
    imageConfig?: { [key: string]: any; };
}

/**
 * Check if a given object implements the GamificationShareTemplate interface.
 */
export function instanceOfGamificationShareTemplate(value: object): value is GamificationShareTemplate {
    return true;
}

export function GamificationShareTemplateFromJSON(json: any): GamificationShareTemplate {
    return GamificationShareTemplateFromJSONTyped(json, false);
}

export function GamificationShareTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): GamificationShareTemplate {
    if (json == null) {
        return json;
    }
    return {
        
        'format': json['format'] == null ? undefined : json['format'],
        'text': json['text'] == null ? undefined : json['text'],
        'imageConfig': json['imageConfig'] == null ? undefined : json['imageConfig'],
    };
}

export function GamificationShareTemplateToJSON(json: any): GamificationShareTemplate {
    return GamificationShareTemplateToJSONTyped(json, false);
}

export function GamificationShareTemplateToJSONTyped(value?: GamificationShareTemplate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'format': value['format'],
        'text': value['text'],
        'imageConfig': value['imageConfig'],
    };
}

